module.exports = __webpack_public_path__ + "static/img/1.c503da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/add/1.png
// module id = RJm7
// module chunks = 1